import TPageHeader from "./TPageHeader.vue";

export default TPageHeader;
